import { Player, Team } from '../_interfaces';

export interface FaceoffTennisMatch {
    sets: Sets;
    status: string;
    winner: string;
    datetime: Date;
    match_type: string;
    tournament: Tournament;
}

export interface Sets {
    team1: TeamScore[];
    team2: TeamScore[];
}

export interface TeamScore {
    games: number;
    order: number;
    tiebreak: null;
}

export interface Tournament {
    id: string;
    name: string;
    year: string;
    location: null;
}

export interface formatttedMatch {
    starts_at: Date,
    team1: {
        is_winner: boolean
        player1: Player
        player2: Player | null
        sets: TeamScore[]
    }
    team2: {
        is_winner: boolean
        player1: Player
        player2: Player | null
        sets: TeamScore[]
    }
    tournament_id: string
    tournament_name: string
    type: string
    winner: string
    status: string
}


export function buildMatchFaceoffs(faceoffs: FaceoffTennisMatch[], team_1: Team, team_2: Team) {
    const result = faceoffs.reduce((collection: formatttedMatch[], match) => {
        collection.push({
            starts_at: match.datetime,
            team1: {
                is_winner: match.winner === 'team1',
                player1: team_1.player1,
                player2: null,
                sets: match.sets.team1
            },
            team2: {
                is_winner: match.winner === 'team2',
                player1: team_2.player1,
                player2: null,
                sets: match.sets.team2
            },
            tournament_id: match.tournament.id,
            tournament_name: match.tournament.name,
            type: match.match_type,
            winner: match.winner,
            status: match?.status
        })

        return collection
    }, [])

    return result.sort((a: formatttedMatch, b: formatttedMatch) => a.starts_at > b.starts_at ? -1 : 1)
}